/* eslint-disable */
import React, { Component } from 'react';
import { Tooltip as ReactTooltip, OverlayTrigger } from 'react-bootstrap';

export default class Tooltip extends Component {
    render() {
        const tooltip = (
            <ReactTooltip id="react-tooltip">{this.props.tooltip}</ReactTooltip>
        );
        return (
            <OverlayTrigger
                overlay={tooltip}
                placement="top"
                delayShow={300}
                delayHide={150}
            >
                {this.props.children}
            </OverlayTrigger>
        );
    }
}
